// extracted by mini-css-extract-plugin
export default {"block":"nm","select":"om","empty":"pm","open":"qm","error":"rm","options":"sm","selectActive":"tm","ornament":"um"};